import { useToast } from "@chakra-ui/react";

export const UseAppToast = () => {
  const toast = useToast();

  const baseToast = (status: "success" | "error" | "warning" | "info", message: string): void => {
    toast({
      title: message,
      status,
      duration: 8000,
      isClosable: true,
      position: "top-right",
    });
  };

  // Existing API (keep for compatibility)
  const successToast = (message: string): void => baseToast("success", message);
  const errorToast = (message: string): void => baseToast("error", message);
  const warningToast = (message: string): void => baseToast("warning", message);
  const infoToast = (message: string): void => baseToast("info", message);

  // Requested API naming (PR comment)
  const showSuccessToast = (message: string): void => baseToast("success", message);
  const showErrorToast = (message: string): void => baseToast("error", message);
  const showWarningToast = (message: string): void => baseToast("warning", message);
  const showInfoToast = (message: string): void => baseToast("info", message);

  return {
    successToast,
    errorToast,
    warningToast,
    infoToast,
    showSuccessToast,
    showErrorToast,
    showWarningToast,
    showInfoToast,
  };
};